import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getUserWallet = createAsyncThunk(
    "/user/getUserWallet",
    async () => {
        const response = await api.get("/user/wallet");
        return response.data;
    }
);

export const createPaypalCheckoutForTopup = createAsyncThunk(
    "user/createPaypalCheckoutForTopupWallet",
    async (topupData) => {        
        const response = await api.post("/user/paypal-checkout/top-up", topupData);
        return response.data;
    }
);

export const fetchPaymentHistory = createAsyncThunk(
    "user/fetchPaymenthistory", 
    async (params) => {
        const response = await api.get(`/payment/user?limit=${params?.limit}&offset=${params?.offset}`)
        return response.data
    }
)

// export const updateUserProfile = createAsyncThunk('/auth/update-user-profile', async (data) => {
//     const response = await api.post('/user/profile', data);
//     return response.data
// })
